
import { makeStyles } from '@mui/styles';

const styles = (theme) => ({

    container: () => {
      return  {
          display: 'flex',
          height: '100vh',
          width: '100%',

          flexDirection: 'column !important',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'scroll',
      };
    },

    body: () => {
      return  {
        display: 'flex',
        width: 'calc(100% - 64px)',
        flexDirection: 'column !important',
        justifyContent: 'center',
        alignItems: 'center',
      };
    },

    subtitle: () => {
      return  {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '20px',
      };
    },

    bodyMessages: () => {
      return  {
        display: 'flex',
        flexDirection: 'column !important',
        fontSize: '14px',
        width: '100%',
        fontWeight: 'regular',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '24px 0px',
        textAlign: 'center',
      };
    },
 
    buttonPanel: () => {
      return  {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      };
    },


    copyButtonOutlined: (p) => {
      const {
        commonUIStyles = {
          copyLinkButton: () => ({}),
        },
      } = p;
      const copyLinkStyles = commonUIStyles.copyLinkButton();
      const styles = {
        backgroundColor: 'transparent !important',
        border: `1px solid ${copyLinkStyles.backgroundColor} !important`,
        color: `${copyLinkStyles.backgroundColor} !important`,
        fontWeight: '400',
        boxShadow: 'none',
      };

      return  {
        '&.MuiButton-root': {
          ...copyLinkStyles,
          ...styles,
          '&[disabled]': {
            ...styles,
          },
        },
      };
    },

    copyButtonSolid: (p) => {
      const {
        commonUIStyles = {
          copyLinkButton: () => ({}),
        },
      } = p;
      const copyLinkStyles = commonUIStyles.copyLinkButton();
      const styles = {
        backgroundColor: `${copyLinkStyles.backgroundColor} !important`,
        color: `${commonUIStyles.foreColor()} !important`,
        border: 'none',
      };

      return  {
        '&.MuiButton-root': {
          ...copyLinkStyles,
          ...styles,
          '&[disabled]': {
            ...styles,
          },
        },
      };
    },

    linkSpace: {
      display: 'flex',
      width: 'calc(100% - 32px)',
      height: '52px',
      fontWeight: 'regular',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',

      marginBottom: '24px',
      border: '1px solid #DEDDDF',
      borderRadius: '8px',
      overflow: 'hidden',
      padding: '0px 10px',
    },

    link: ({ commonUIStyles }) => {
      return {
        ...commonUIStyles.textLink(),
        display: 'block',
        width: '100%',
        fontSize: '14px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        textTransform: 'none',
      };
    },
    
    copyButtonBase: {
      '&.MuiButtonBase-root': {
        whiteSpace: 'nowrap',
        flexShrink: 0,
        minWidth: 'auto',
        padding: '0 4px',
      }
    },


    help: {
      marginTop: '24px',
      marginBottom: '52px',
      display: 'flex',
      flexDirection: 'row',
      width: 'calc(100% - 64px)',
      justifyContent: 'center',
    },
});

export default styles;
export const useStyles = makeStyles(styles);
